import { TipoPortal } from "../../../../services/variables";
import NavMenu from "../../../../components/public/others/Navbar";
import NavMenuCM from "../../../../components/public/others/NavbarCM";
import Footer from "../../../../components/public/others/Footer";
import styles from "../../../../styles/module/transparency/dados_abertos.module.css";

import buttonsSACOP from "../../../../components/jsons/routesTranparency/routesSacopAndLicitacoes";
import buttonsATOS from "../../../../components/jsons/routesTranparency/routesAtcsAdministrative";
import {
  CSVexports,
  JSONexports,
  XLSexports,
  useGetAtos,
  useGetSacops,
} from "../../../../components/public/transparency/dados-abertos";
import { useState } from "react";

export default function DadosAbertosPage() {
  const [sacop, setSacop] = useState(null);
  const [ato, setAto] = useState(null);
  const { data, isLoading } = useGetAtos(ato);
  const { data: sacopData, isLoading: sacopLoading } = useGetSacops(sacop);

  function handleDownload({ tipo, metodo }) {
    setAto(tipo);
    if (metodo == "json") {
      if (!isLoading && data != undefined && ato !== null) {
        JSONexports({ data: data.res, select: ato });
        return true;
      }
    }
    if (metodo == "xls") {
      if (!isLoading && data != undefined && ato !== null) {
        XLSexports({ data: data.res, select: ato });
        return true;
      }
    } else if (metodo == "csv") {
      if (!isLoading && data != undefined && ato !== null) {
        CSVexports({ data: data.res, select: ato });
        return true;
      }
    }
    return false;
  }

  function handleDownloadSacop({ tipo, metodo, declaracao }) {
    setSacop(tipo);
    if (metodo == "json") {
      if (declaracao != undefined && declaracao != null) {
        setAto(declaracao);
        if (
          !sacopLoading &&
          sacopData != undefined &&
          !isLoading &&
          data != undefined
        ) {
          let concat = [...sacopData, ["DECLARAÇÕES EM SEGUIDA"], ...data.res];
          JSONexports({ data: concat, select: sacop });
        }
        return true;
      } else {
        if (!sacopLoading && sacopData != undefined && !isLoading) {
          JSONexports({ data: sacopData, select: sacop });
        }
        return true;
      }
    }
    if (metodo == "xls") {
      if (declaracao != undefined && declaracao != null) {
        setAto(declaracao);
        if (
          !sacopLoading &&
          sacopData != undefined &&
          !isLoading &&
          data != undefined
        ) {
          let concat = [...sacopData, ["DECLARAÇÕES EM SEGUIDA"], ...data.res];
          XLSexports({ data: concat, select: sacop });
        }
        return true;
      } else {
        if (!sacopLoading && sacopData != undefined && !isLoading) {
          XLSexports({ data: sacopData, select: sacop });
        }
        return true;
      }
    }
    if (metodo == "csv") {
      if (declaracao != undefined && declaracao != null) {
        setAto(declaracao);
        if (
          !sacopLoading &&
          sacopData != undefined &&
          !isLoading &&
          data != undefined
        ) {
          let concat = [...sacopData, ["DECLARAÇÕES EM SEGUIDA"], ...data.res];
          CSVexports({ data: concat, select: sacop });
        }
        return true;
      } else {
        if (!sacopLoading && sacopData != undefined && !isLoading) {
          CSVexports({ data: sacopData, select: sacop });
        }
        return true;
      }
    }
    return false;
  }

  return (
    <>
      {TipoPortal == 3 ? <NavMenu /> : <NavMenuCM />}
      <div className="section-title rotes_pages">
        <div className="section-title-portarias">
          <h4>Dados Abertos</h4>
          <p>Lista das informações abaixo para exportar</p>
          <p className={styles.dados_publicos_info}>
            Os dados públicos são de todos. Por isso, disponibilizamos essas
            informações de forma aberta, para promover transparência,
            participação e inovação. Veja como usá-los com responsabilidade:
            <br />
            <strong>1. Acesso é livre e gratuito</strong>
            <br />
            Qualquer pessoa pode consultar, baixar e usar os dados, sem precisar
            de autorização.
            <br />
            <strong>2. Pode usar, só cite a fonte</strong>
            <br />
            Você pode compartilhar, transformar e até usar para fins comerciais
            — desde que mencione a fonte original dos dados.
            <br />
            <strong>3. Use com responsabilidade</strong>
            <br />
            A instituição não se responsabiliza por análises feitas a partir dos
            dados. Recomendamos atenção ao contexto e às atualizações.
            <br />
            <strong>4. Não altere o sentido dos dados</strong>
            <br />
            Evite usar os dados de forma que gere confusão ou desinforme.
            Preserve o conteúdo original e use com ética.
            <br />
            <strong>5. Proteção de dados pessoais</strong>
            <br />
            Os dados disponibilizados não devem conter informações pessoais.
            Caso encontre algo fora do padrão, nos avise.
            <br />
            <strong>6. Reforce a transparência</strong>
            <br />
            Ao utilizar os dados, indique a data de acesso e, se possível,
            compartilhe suas soluções com a comunidade.
            <br />
            <strong>7. Contra o uso indevido</strong>
            <br />É proibido utilizar os dados para manipular informações ou
            disseminar notícias falsas.Add commentMore actions
          </p>
        </div>
        <div className={styles.container_butons}>
          {buttonsSACOP.map((i, index) => (
            <div key={index} className={styles.button_rotes}>
              <p>{i.TITLE}</p>
              <div className={styles.acoes}>
                <b
                  onClick={() =>
                    handleDownloadSacop({
                      tipo: i.SELECT,
                      metodo: "json",
                      declaracao: i["SELECT-TYPE-DECLARACAO"],
                    })
                  }
                >
                  JSON
                </b>
                <b
                  onClick={() =>
                    handleDownloadSacop({
                      tipo: i.SELECT,
                      metodo: "xls",
                      declaracao: i["SELECT-TYPE-DECLARACAO"],
                    })
                  }
                >
                  XLS
                </b>
                <b
                  onClick={() =>
                    handleDownloadSacop({
                      tipo: i.SELECT,
                      metodo: "csv",
                      declaracao: i["SELECT-TYPE-DECLARACAO"],
                    })
                  }
                >
                  CSV
                </b>
              </div>
            </div>
          ))}
          {buttonsATOS.map((i, index) => (
            <div key={index} className={styles.button_rotes}>
              <p>{i.TITLE}</p>
              <div className={styles.acoes}>
                <b
                  onClick={() =>
                    handleDownload({ tipo: i.SELECT, metodo: "json" })
                  }
                >
                  JSON
                </b>
                <b
                  onClick={() =>
                    handleDownload({ tipo: i.SELECT, metodo: "xls" })
                  }
                >
                  XLS
                </b>
                <b
                  onClick={() =>
                    handleDownload({ tipo: i.SELECT, metodo: "csv" })
                  }
                >
                  CSV
                </b>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}
